import React from 'react';
import Client from './components/Client';
import { useSearchParams } from 'react-router-dom';
import { useDataStore } from './dataStore';
import { findLanguage, getLanguageIref, resolveSelectedLanguage } from './i18n';
import {
  fetchMobileText,
  getMobileTextValue,
  MobileHtmlContent,
  MobileStandalonePage,
  MobileSurface,
} from './components/MobileStandalone';

// Wrapper component
function TermsWrapper() {
  const [searchParams] = useSearchParams();
  const { languages, selectedLanguage, defaultLanguage, languageReady } = useDataStore();
  const queryLanguage = searchParams.get('language') || searchParams.get('lang') || '';
  const shouldWaitForQueryLanguage = Boolean(queryLanguage) && !languageReady;
  const resolvedQueryLanguage = queryLanguage ? findLanguage(languages, queryLanguage) : null;
  const language = resolvedQueryLanguage || resolveSelectedLanguage(languages, selectedLanguage?.iref, defaultLanguage);

  if (shouldWaitForQueryLanguage) {
    return (
      <MobileStandalonePage center maxWidth={680}>
        <MobileSurface sx={{ minHeight: 180 }} />
      </MobileStandalonePage>
    );
  }

  return <Terms language={language} defaultLanguage={defaultLanguage} />;
}
class Terms extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      client: new Client ( "none" ),
      terms: {},
      loaded: false,
    };

    this.getData = this.getData.bind(this);
  }

  
  componentDidMount() {
    this.getData ( );
  }

  componentDidUpdate(prevProps) {
    if (
      getLanguageIref(prevProps.language) !== getLanguageIref(this.props.language) ||
      getLanguageIref(prevProps.defaultLanguage) !== getLanguageIref(this.props.defaultLanguage)
    ) {
      this.setState({ loaded: false }, this.getData);
    }
  }

  componentWillUnmount() {
  }

  getData ( ) {
    if (this.state.loaded) return;
    const languageIref = getLanguageIref(this.props.language);
    const terms = fetchMobileText(this.state.client, "TERMS", languageIref);

    this.setState({
      terms: terms || {},
      loaded: true,
    });
  }
  
  render() {
    const html = getMobileTextValue(
      this.state.terms,
      "",
      this.props.language,
      this.props.defaultLanguage
    );

    return (
      <MobileStandalonePage maxWidth={680}>
        <MobileSurface sx={{ p: { xs: 2, sm: 3 } }}>
          <MobileHtmlContent html={html} />
        </MobileSurface>
      </MobileStandalonePage>
    );
  }
}

export default TermsWrapper;
